import { IResultMapPointCalculated } from 'modules/admin-panel/pages/results/models';

export const createCoordinatesMap = (
	mapList: IResultMapPointCalculated[] | undefined,
): Record<string, IResultMapPointCalculated> | undefined => {
	if (!mapList || !mapList.length) return;

	const mapMap: Record<string, IResultMapPointCalculated> = {};
	return mapList.reduce((acc, mapItem) => {
		if (mapItem) {
			acc[`${mapItem?.latitude}${mapItem?.longitude}`] = mapItem;
		}

		return acc;
	}, mapMap);
};
